(ns storrito.unsplash.core
  (:require [goog.object :as obj]
            ["unsplash-js" :as unsplash-js]))

(def unsplash-settings
  #js{:applicationId "932bcd5e0a05cd7dfaaf9b4d3f4ada81739e3e6c4f89207681aa45c16eef4dc8"
      :callbackUrl "urn:ietf:wg:oauth:2.0:oob"})

(def unsplash
  (new unsplash-js/default unsplash-settings))

(defn extract-photo
  [image]
  (let [value (fn [& ks]
                (apply obj/getValueByKeys image ks))]
    {:id (value "id")
     :instagram-username (value "user" "instagram_username")
     :name (value "user" "name")
     :html-link (value "user" "links" "html")
     :thumb (value "urls" "thumb")
     :small (value "urls" "small")
     :src (value "urls" "regular")
     :color (value "color")}))

(defn extract-photo-map
  "The photos of an Unsplash `results` array, in their order (the
   relevance order of a search)."
  [results]
  (mapv extract-photo (array-seq results)))

(defn promise-unsplash-result [result]
  (js/Promise.
    (fn [resolve reject]
      (if (= result.status 200)
        (resolve
          (.json result))
        (reject
          {:unsplash-error "Service is unavailable"
           :status result.status})))))

(defn get-unsplash-photo [id width height]
  (-> (unsplash.photos.getPhoto
        id
        width
        height)
      (.then promise-unsplash-result)))

(defn download-photo [photo-json]
  (unsplash.photos.downloadPhoto photo-json))

(defn search-unsplash-photos [{:keys [query page per-page]}]
  (-> (unsplash.search.photos
        query
        page
        per-page)
      (.then promise-unsplash-result)
      (.then (fn [json]
              (let [total-pages (obj/get json "total_pages")
                    photos (extract-photo-map json.results)]
                {:photos photos
                 :page page
                 :total-pages total-pages})))))

(defn get-popular-photos
  "The `page` of Unsplash's popular photos."
  [{:keys [page per-page]}]
  (-> (unsplash.photos.listPhotos
        page
        per-page
        "popular")
      (.then promise-unsplash-result)
      (.then (fn [json]
               {:photos (extract-photo-map json)
                :page page}))))

(comment
  (-> (search-unsplash-photos {:query "mountains" :page 1 :per-page 24})
      (.then (fn [result] (def result result))))

  (map :name (:photos result))
  )
